import { useDispatch } from "react-redux";
import AppSwitch from "../../Atoms/Input/Switch/Switch";
import { toggleProductStatusRequest } from "services/modules/products";
import { toast } from "react-toastify";

export default function ToggleStatus({ data, refetch }) {
  const dispatch = useDispatch();

  const handleToggle = (row, field, checked) => {
    const action = () => {
      toast.success(
        `Product status updated to ${checked ? "Active" : "Disabled"}`
      );
      refetch && refetch();
    };

    dispatch(
      toggleProductStatusRequest({
        id: data.id,
        body: {
          active: checked,
        },
        action,
      })
    );
  };

  return (
    <AppSwitch checked={data?.is_visible} onChange={handleToggle} row={data} />
  );
}
